(function() {
    'use strict';

    angular.module('swif.ui')
    .config(route)
    .controller('activateUserController', activateUserController)
    .controller('signUpController', signUpController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/activate/:uid', {
            templateUrl: 'partials/openbase/activateUser.html',
            controller: activateUserController,
            controllerAs: '$ctrl',
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({public: true});
                }]
            }
        }).when('/sign-up/', {
            templateUrl: 'partials/openbase/sign_up.html',
            controller: signUpController,
            controllerAs: '$ctrl',
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({public: true});
                }]
            }
        }).when('/forgot-password', {
            templateUrl: 'partials/openbase/forgot_password.html',
            controller: forgotPasswordController,
            controllerAs: '$ctrl',
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({public: true});
                }]
            }
        }).when('/reset-password', {
            templateUrl: 'partials/openbase/reset_password.html',
            controller: resetPasswordController,
            controllerAs: '$ctrl',
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({public: true});
                }]
            }
        })
    }

    function activateUserController($scope, $routeParams, swifFrameworkService) {
        'ngInject';
        var $ctrl = this;
        var swif = swifFrameworkService;
        $ctrl.success = false;

        function onLoad() {
            // activate user
            var userId = parseInt($routeParams.uid, 10);
            var http = {
                url: '/web/user/activate',
                params: {
                    db: swif.settings.app.db,
                    uid: userId
                }
            }
            swif.data.post(undefined, http).then(function(res) {
                $ctrl.success = true;
            })
        }

        onLoad();
    }

    function signUpController($scope, $routeParams, swifFrameworkService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.success = false;
        $ctrl.alreadyExists = false;
        $ctrl.acceptLegals = false;
        var swif = swifFrameworkService;

        $ctrl.createUser = function(user){
            // activate user
            user.login = user.email;
            user.name = user.lastname.toUpperCase() + " " + user.firstname;
            user.is_citizen = true;

            var http = {
                url: '/web/user/create',
                params: {
                    db: swif.settings.app.db,
                    data: user
                }
            }
            swif.data.post(undefined, http, false).then(
                function(res) {
                    $ctrl.success = true;
                },
                function(err){
                    $ctrl.alreadyExists = true;
                });
        };

        $scope.is_valid_password = true;

        $scope.$watch('model', function (newV) {
            if (newV === undefined) {
                return;
            }

            if (newV.new_password && newV.new_password_copy) {
                if (newV.new_password_copy === newV.new_password) {
                    $scope.is_valid_password = true;
                    $scope.form.$setValidity('PasswordEquality', true);
                } else {
                    $scope.is_valid_password = false;
                    $scope.form.$setValidity('PasswordEquality', false);
                }
            } else {
                $scope.is_valid_password = true;
                $scope.form.$setValidity('PasswordEquality', true);
            }
        }, true);
    }

    function forgotPasswordController($scope, swifFrameworkService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.success = false;
        $ctrl.error = false;
        $ctrl.loading = false;

        var swif = swifFrameworkService;

        $ctrl.requestResetPassword = function(model) {
            $ctrl.loading = true;
            $ctrl.error = false;

            var http = {
                url: '/web/user/forgot_password',
                params: {
                    db: swif.settings.app.db,
                    login: model.login
                }
            }
            swif.data.post(undefined, http, false).then(
                function (res) {
                    $ctrl.success = true;
                    $ctrl.loading = false;
                },
                function (err) {
                    $ctrl.error = true;
                    $ctrl.loading = false;
                });
        }
    }

    function resetPasswordController($scope, $routeParams, swifFrameworkService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.success = false;
        $ctrl.error = false;
        $ctrl.loading = false;
        $ctrl.isValidPassword = true;
        $ctrl.token = $routeParams.token;

        const swif = swifFrameworkService;
        $scope.mobileApplication = swif.settings.app.mobileApplication;

        $scope.$watch('model', function (newV) {
            if (newV === undefined) {
                return;
            }

            if (newV.new_password && newV.new_password_copy) {
                if (newV.new_password_copy === newV.new_password) {
                    $ctrl.isValidPassword = true;
                    $scope.form.$setValidity('PasswordEquality', true);
                } else {
                    $ctrl.isValidPassword = false;
                    $scope.form.$setValidity('PasswordEquality', false);
                }
            } else {
                $ctrl.isValidPassword = true;
                $scope.form.$setValidity('PasswordEquality', true);
            }
        }, true);

        $ctrl.resetPassword = function(model) {
            $ctrl.loading = true;
            $ctrl.error = false;

            var http = {
                url: '/web/user/reset_password',
                params: {
                    db: swif.settings.app.db,
                    token: $ctrl.token,
                    password: model.new_password,
                    confirm_pwd: model.new_password_copy
                }
            }
            swif.data.post(undefined, http, false).then(
                function (res) {
                    $ctrl.success = true;
                    $ctrl.loading = false;
                },
                function (err) {
                    $ctrl.error = true;
                    $ctrl.loading = false;
                });
        }
    }
})();
